import './index.scss';

import { Menu, Modal } from '@arco-design/web-react';
import { useNavigate } from '@modern-js/runtime/router';
import { FC, useContext } from 'react';
import GlobalStore from '@store/globalStore';
import { useModel } from '@modern-js/runtime/model';
import useLocale from '@hooks/useLocale';
import { IconBodyText, IconEditBtn, IconExportBtn, IconInfoCircleBtn } from '@arco-iconbox/react-hkgai-government-icon';
import { clearBrowserCookie } from '@/api/request';
import { CoreOperateConfig } from '@/config/new.track.config';
import { trackEvent } from '@/utils/pageTracker';
// const { SubMenu } = Menu;
// const MenuItem = Menu.Item;

const UserDropdown: FC = () => {
  const navigate = useNavigate();
  const locale = useLocale();
  const [, actions] = useModel(GlobalStore);

  const onClickMenuItem = (key: string) => {
    switch (key) {
      case 'changePassword':
        navigate('/pwd/reset');
        trackEvent(CoreOperateConfig.CONFIRM_RESET_PASSWORD);
        break;
      case 'logout':
        actions.onLogOut(() => {
          clearBrowserCookie();
          localStorage.removeItem('userInfo');
          navigate('/login', { replace: true });
        });
        break;
      case 'termOfUse':
        Modal.info({
          icon: null,
          wrapClassName: 'term-of-use-modal',
          title: locale.term_of_use_title,
          content: locale.term_of_use_content,
        });
        break;
      case 'fqa':
        window.open('https://hkgpt-application.sg.larksuite.com/docx/UichdAOCOoku1HxuYvsleEgdgYd', '_black');
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Menu onClickMenuItem={onClickMenuItem} mode="pop" className="menu-wrap">
        {/* <Menu.Item key="fqa" className="menu-item-hover">
          <IconQuestionCircle /> FAQ
        </Menu.Item> */}
        <Menu.Item key="changePassword" className="menu-item-hover">
          <IconEditBtn /> {locale.user_dropdown_menu_item_change_password}
        </Menu.Item>
        <Menu.Item key="termOfUse" className="menu-item-hover">
          <IconBodyText /> {locale.term_of_use_title}
        </Menu.Item>
        <Menu.Item key="app_version" className="menu-item-hover" disabled>
          <IconInfoCircleBtn /> {`v ${process.env.APP_VERSION}`}
        </Menu.Item>
        <Menu.Item key="logout" className="menu-item-hover">
          <IconExportBtn /> {locale.user_dropdown_menu_item_log_out}
        </Menu.Item>
      </Menu>
    </>
  );
};

export default UserDropdown;
